var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3895 3.45894C11.5074 3.0834 12.0389 3.0834 12.1568 3.45894L13.1498 6.62056C13.1892 6.74604 13.2875 6.84432 13.413 6.88373L16.5746 7.87668C16.9501 7.99463 16.9501 8.52608 16.5746 8.64403L13.413 9.63698C13.2875 9.67639 13.1892 9.77467 13.1498 9.90015L12.1568 13.0618C12.0389 13.4373 11.5074 13.4373 11.3895 13.0618L10.3966 9.90015C10.3571 9.77467 10.2589 9.67639 10.1334 9.63698L6.97175 8.64403C6.59622 8.52608 6.59622 7.99463 6.97175 7.87668L10.1334 6.88373C10.2589 6.84432 10.3571 6.74604 10.3966 6.62056L11.3895 3.45894Z",
    fill: "#DB7800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10218 10.6961C6.20595 10.2938 6.77722 10.2938 6.88099 10.6961L7.3116 12.3654C7.34816 12.5071 7.45883 12.6178 7.60055 12.6544L9.26988 13.085C9.67215 13.1887 9.67215 13.76 9.26989 13.8638L7.60055 14.2944C7.45883 14.3309 7.34816 14.4416 7.3116 14.5833L6.88099 16.2527C6.77722 16.6549 6.20595 16.6549 6.10218 16.2527L5.67157 14.5833C5.63501 14.4416 5.52434 14.3309 5.38262 14.2944L3.71329 13.8638C3.31102 13.76 3.31102 13.1887 3.71328 13.085L5.38262 12.6544C5.52434 12.6178 5.63501 12.5071 5.67157 12.3654L6.10218 10.6961Z",
    fill: "#DB7800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsIcon);
export default __webpack_public_path__ + "static/media/stars-icon.58563b3e.svg";
export { ForwardRef as ReactComponent };